import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

export const styles = {
	visible: {
		display: 'block',
	},
	hidden: {
		display: 'none',
	},
}

class TabContent extends PureComponent {
	render() {
		const displayStyle = this.props.isVisible ? styles.visible : styles.hidden

		return (
			<div
				className="tab-content"
				style={{ ...this.props.style, ...displayStyle }}
			>
				{this.props.children}
			</div>
		)
	}
}

TabContent.propTypes = {
	for: PropTypes.string.isRequired,
	isVisible: PropTypes.bool,
	style: PropTypes.object,
	children: PropTypes.node,
}

export default TabContent
